import { useState } from "react";
import CustomRangepicker from "../../common/rangepicker";
import ChatUser from "./chatUser";
import { useParams } from "react-router-dom";

const ChatSidebar = ({
  familyMembers,
  activityList,
  prepareSearch,
  resetdate,
  resetFilter,
  selectedFamily,
  onFamilySelect,
}) => {
  const familyDatas = familyMembers.family_members;

  const handleFamilyChange = (e) => {
    const value = e.target.value;
    onFamilySelect(value);
  };

  return (
    <div className="col-sm-12 col-md-12 col-lg-5 col-xl-4">
      <div className="card custom-card" style={{ backgroundColor: "#fff" }}>
        <div className="main-content-app pt-0">
          <div className="main-content-left main-content-left-chat">
            {/* Family Member Select - TOP */}
            <div className="card-body pb-1 d-flex mb-0">
              <select
                value={selectedFamily}
                onChange={handleFamilyChange}
                className="form-control"
              >
                <option value="">-- Select Family Member --</option>
                {Array.isArray(familyDatas) && familyDatas.map((familyData, index) => (
                  <option key={familyData._id || index} value={familyData._id}>
                    {familyData.name}
                  </option>
                ))}
              </select>
            </div>
            {/* Search + Reset Filter */}
            <div className="d-flex justify-content-between">
              <div className="card-body d-flex">
                <CustomRangepicker
                  GetDateRange={(e) => prepareSearch("createdAt", e)}
                  resetdate={resetdate}
                />

                {/* <button class="btn ripple btn-primary" type="button" onClick={(e)=>resetFilter(e)}>Reset Filter</button> */}
                <button
                  className="btn ripple btn-main-primary signbtn"
                  onClick={(e) => resetFilter(e)}
                >
                  Reset Filter
                </button>
              </div>
            </div>

            {/* Tabs */}
            {/* <nav className="nav main-nav-line main-nav-line-chat card-body">
              <button className="nav-link active">Recent Chat</button>
              <button className="nav-link">Calls</button>
              <button className="nav-link">Contacts</button>
            </nav> */}

            {/* Chat List */}
            <div className="main-chat-list">
              {activityList.map((activity, index) => (
                <ChatUser
                  key={index}
                  activity={activity}
                  name="Socrates Itumay"
                  time="2 hours"
                  message="Nam quam nunc, blandit vel aecenas..."
                  img="5.jpg"
                  unread={2}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatSidebar;
